<template lang="pug">

include ../../../../pug/mixins/index

+b.slides(:class='sliderClass')
  +e.SWIPER.list(:options='swiperOptions', ref='swiper')
    slot

  slot(name='pagination', slot='pagination')

  //- div(:class=`{ [slotPrev.data.staticClass]: slotPrev.data }`, slot='button-prev', v-show='slotPrev.data')
  //- div(:class=`{ [slotNext.data.staticClass]: slotNext.data }`, slot='button-next', v-show='slotNext.data')
  //- span(slot='button-prev', v-if='slotPrev'): node-renderer(:node="slotPrev")
  //- span(slot='button-next', v-if='slotNext'): node-renderer(:node="slotNext")
  +e.next(@click.prevent='slideNext', v-show='hasNext'): slot(name='button-next')
  +e.prev(@click.prevent='slidePrev', v-show='hasPrev'): slot(name='button-prev')

    //- span(slot='button-next'):
    //- span(slot='button-prev'):

</template>

<script>

import merge from 'lodash.merge'

const NodeRenderer = {
  name: 'node-renderer',
  functional: true,
  props: ['node'],

  render(h, context) {
    return context.props.node[0]
  }
}

export default {
  props: {
    theme: { type: String },
    in: { type: String },
    options: { type: Object, default() { return {} } },
  },

  inject: ['preloaderService'],
  components: {
    NodeRenderer,
  },

  data() {
    let that = this

    return {
      swiperOptions: merge({
        slidesPerView: 1,
        // notNextTick: true,
        // initialSlide: 1,
        paginationClickable :true,
        observer: true,
        observeParents: true,
        loop: false,
        autoHeight: true,
        onSlideNextEnd(swiper) { that.checkArrows(swiper) },
        onSlidePrevEnd(swiper) { that.checkArrows(swiper) },
        onInit(swiper) { that.checkArrows(swiper) },
        onSlideChangeEnd(swiper) { that.checkArrows(swiper) },
        // simulateTouch: false,
        // shortSwipes: false,
        // longSwipes: false,
        // noSwiping: true,
        // allowSwipeToPrev: false,
        // allowSwipeToNext: false,

        debugger: false,
      }, this.options, { prevButton: null, nextButton: null }),

      hasNext: false,
      hasPrev: false
    }
  },

  computed: {
    sliderClass() {
      return {
        [`slider--theme-${this.theme}`]: !!this.theme,
        [`slider--in-${this.in}`]: !!this.in,
      }
    },

    slotNext() { return (this.$slots['button-next'] || [ { data: {} }])[0] },
    slotPrev() { return (this.$slots['button-prev'] || [ { data: {} }])[0] },

    // hasNext() {
    //   try {
    //   } catch(e) { console.log(e) }

    //   return false
    // },

    // hasPrev() {
    //   try {
    //     let swp = this.$refs.swiper.swiper
    //     return swp.activeIndex != 0 && swp.slidesGrid.length > 0
    //   } catch(e) { console.log(e) }

    //   return false
    // },
  },

  mounted() {
    this.preloaderService.$on('preloadingFinished', x => this.$nextTick(x => {
      this.update()
      this.checkArrows()
    }))
  },

  methods: {
    update() {
      this.$refs.swiper.swiper.update()
    },

    checkArrows(swiper) {
      let swp = swiper || this.$refs.swiper.swiper

      this.hasPrev = swp.snapIndex != swp.snapGrid.length - 1
      this.hasNext = swp.snapIndex != 0 && swp.snapGrid.length > 0
    },

    slideNext() {
      this.checkArrows()
      this.$refs.swiper.swiper.slidePrev()
    },

    slidePrev() {
      this.checkArrows()
      this.$refs.swiper.swiper.slideNext()
    },
  }
}

</script>



// WEBPACK FOOTER //
// src/js/shared/components/slider/slider.vue